(() => {
  if (customElements.get('mdf-balloon-gifts')) return;
  customElements.define('mdf-balloon-gifts', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.observeLegacy(); return; }
      try { this.catalog = JSON.parse(this.querySelector('[data-catalog]')?.textContent || '{}'); }
      catch { this.querySelector('[data-open]').disabled = true; return; }
      if (!Array.isArray(this.catalog.bouquet) || !Array.isArray(this.catalog.numbers)) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.kind = this.querySelector('[data-kind]');
      this.color = this.querySelector('[data-color]');
      this.theme = this.querySelector('[data-theme]');
      this.digit = this.querySelector('[data-digit]');
      this.second = this.querySelector('[data-second]');
      this.status = this.querySelector('[role=status]');
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100);
      this.opener = this.querySelector('[data-open]');
      this.opener.disabled = false;
      this.opener.setAttribute('aria-haspopup','dialog');
      this.opener.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.kind.focus();
      });
      this.dialog.addEventListener('close', () => { if (this.opener.isConnected) this.opener.focus(); });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.form.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target === this.color) this.updateDigits();
        this.status.textContent = '';
        this.querySelector('[data-cart]').hidden = true;
        this.update();
      });
      this.form.addEventListener('submit', event => this.add(event));
      this.update();
      this.suppressLegacy();
      this.observer = new MutationObserver(() => this.suppressLegacy());
      this.observeLegacy();
    }
    observeLegacy() { this.observer?.observe(document.body, {childList:true,subtree:true}); }
    disconnectedCallback() { this.observer?.disconnect(); if(this.dialog?.open)this.dialog.close(); }
    suppressLegacy() {
      document.querySelectorAll('#infiniteoptions-container').forEach(container => {
        const group = container.querySelector('.balloon-bundle-cstm');
        if (!group) return;
        const none = group.querySelector('input[type=radio][value="None"]');
        if (none && !none.checked) { none.disabled = false; none.checked = true; none.dispatchEvent(new Event('change', {bubbles:true})); }
        const labels = ['Choose Theme','Choose Balloon Theme','Choose Balloon Number Color','Choose Gold Balloon Number','Choose Silver Balloon Number','Choose Rose Gold Balloon Number','Add Another Balloon Number Quantity','Choose Second Gold Balloon Number','Choose Second Silver Balloon Number','Choose Second Rose Gold Balloon Number'];
        const fields = [group];
        let sibling = group.nextElementSibling;
        while (sibling) {
          const label = sibling.querySelector('label');
          if (!label || !labels.includes(label.textContent.trim())) break;
          fields.push(sibling); sibling = sibling.nextElementSibling;
        }
        fields.forEach(field => {
          field.classList.add('mdf-old-balloon-field');
          field.querySelectorAll('input,select,textarea').forEach(input => {
            input.required = false;
            input.disabled = true;
            input.removeAttribute('name');
          });
        });
      });
    }
    updateDigits() {
      [this.digit, this.second].forEach((select,index) => {
        const previousDigit = this.catalog.numbers.find(v => String(v.id) === select.value)?.option2;
        select.replaceChildren(new Option(index ? 'No second digit' : 'Choose a digit', ''));
        this.catalog.numbers.filter(v => v.option1 === this.color.value).sort((a,b) => Number(a.option2)-Number(b.option2)).forEach(v => {
          const option = new Option(v.option2 + (v.available ? '' : ' — Sold out'), String(v.id));
          option.disabled = !v.available; select.add(option);
        });
        const equivalent = this.catalog.numbers.find(v => v.option1 === this.color.value && v.option2 === previousDigit && v.available);
        if (equivalent) select.value = String(equivalent.id);
      });
    }
    selection() {
      if (this.kind.value === 'number') {
        if (!this.color.value || !this.digit.value) return [];
        const variants = [this.digit.value,this.second.value].filter(Boolean).map(id => this.catalog.numbers.find(v => String(v.id) === id && v.option1 === this.color.value && v.available));
        if (variants.some(v => !v)) return [];
        const display = variants.map(v => v.option2).join('');
        const items = [];
        variants.forEach(v => { const same = items.find(item => item.id === v.id); if (same) same.quantity++; else items.push({id:v.id,quantity:1,properties:{'Number display':display},price:v.price}); });
        return items;
      }
      const variant = this.catalog.bouquet.find(v => String(v.id) === this.kind.value && v.available);
      return variant && this.theme.value ? [{id:variant.id,quantity:1,price:variant.price,properties:{Theme:this.theme.value,'Balloon bouquet':this.kind.selectedOptions[0].dataset.count + ' balloons'}}] : [];
    }
    update() {
      const number = this.kind.value === 'number';
      this.querySelector('[data-numbers]').hidden = !number;
      this.querySelector('[data-bouquet]').hidden = number || !this.kind.value;
      this.theme.disabled = number || !this.kind.value; this.theme.required = !this.theme.disabled;
      this.color.disabled = !number; this.color.required = number;
      this.digit.disabled = !number || !this.color.value; this.digit.required = number;
      this.second.disabled = this.digit.disabled;
      const items = this.selection();
      this.querySelector('[data-summary]').textContent = items.length ? (number ? this.color.value + ' · ' + items[0].properties['Number display'] : this.kind.selectedOptions[0].dataset.count + ' balloons · ' + this.theme.value) + ' — ' + this.money(items.reduce((sum,item) => sum + item.price * item.quantity,0)) : 'Choose your balloons above.';
    }
    async add(event) {
      event.preventDefault(); event.stopPropagation();
      if (this.busy || !this.form.reportValidity()) return;
      const items = this.selection();
      if (!items.length) { this.status.textContent = 'Please complete your balloon choices.'; return; }
      this.busy = true;
      this.form.setAttribute('aria-busy','true');
      this.querySelector('[data-cart]').hidden = true;
      const controls = Array.from(this.form.querySelectorAll('button,select'));
      const priorDisabled = controls.map(control => control.disabled);
      controls.forEach(control => control.disabled = true);
      this.status.textContent = 'Adding your balloons…';
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(({price,...item}) => item)})});
        let data;
        try { data = await response.json(); } catch { throw new TypeError('Unconfirmed cart response'); }
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'This selection is unavailable. Please choose another.');
        this.status.textContent = 'Your balloons have been added to your cart.';
        this.dispatchEvent(new CustomEvent('updateCart',{bubbles:true,composed:true,detail:{callback:()=>{}}}));
      } catch(error) { this.status.textContent = error instanceof TypeError ? 'We could not confirm the addition. Check your cart before trying again.' : error.message; }
      finally { this.busy = false; this.form.removeAttribute('aria-busy'); controls.forEach((control,index) => control.disabled = priorDisabled[index]); this.update(); this.querySelector('[data-cart]').hidden = false; }
    }
  });
})();